import React, { Component } from 'react';
import LoginAccountInput from "../LoginAccountInput";
import ImgCodeInput from "../ImgCodeInput";
import BsyBtn from "../BsyBtn";
import EntryInputCode from "../EntryInputCode";
import './index.css'
import tipAlert from "../BsyAlertTip/Staticize";
import PubSub from "pubsub-js";
import LoginPasswordLevel from "../LoginPasswordLevel";

class ForgetPassword extends Component {
    state = {
        showClear: false,
        password: "",
        showPasswordType: false,
        showPassword: false,
        passLevel: false,
        errorInput:false,
        errMsg:'',
        pageSwitch: {
            showEntryInput: false,
            showSetPasswordInput: false,
            showForgetCont: true
        }
    }

    constructor(props) {
        super(props);
        this.pubsub_token = PubSub.subscribe("levelPass", (topic, value) => {
            this.setState({
                passLevel: value.value
            })
        })
    }

    forgetPasswordCode = (values, state, cd) => {
        this.timer1 = setTimeout(() => {
            const data = {
                "mode": "getpwd",
                "data": {
                    "code": values
                }
            }
            React.axios('/user/signin', data).then(res => {
                if (res.data.code === 200) {
                    tipAlert({
                        type: "success",
                        msg: res.data.msg
                    })
                    this.setShowPage("showSetPasswordInput")
                }else if(res.data.code===400){
                    tipAlert({
                        type: "error",
                        msg : res.data.msg
                    })
                }
            }).catch(res => {
                const res1 =  res.response ? res.response.data : res.data;
                if (res1.toString().indexOf('"Message":"OK"') === -1) {
                    if (res1.toString().indexOf('code')) {
                        // tipAlert({
                        //     type: "error",
                        //     msg: res1.msg
                        // })
                        cd && cd(!0, res1.msg);
                    }
                    else {
                        // tipAlert({
                        //     type: "error",
                        //     msg: React.language("System.error")
                        // })
                        cd && cd(!0, React.language("System.error"));
                    }
                } else {
                    tipAlert({
                        type: "success",
                        msg: res1.msg
                    })
                    this.setShowPage("showSetPasswordInput")
                }
            })
        }, 300)
    }

    accountValue = (ref) => {
        this.account = ref
    }

    imgCodeValue = (ref) => {
        this.imgCode = ref
    }

    passwordValue = (ref) => {
        this.passwordVal = ref
    }

    componentDidMount() {
        const el = document.getElementsByClassName("ForgetPassword")[0]
        el.addEventListener("keyup", (event) => {
            if (event.keyCode === 13) {
                this.forgetLogin()
            }
        })
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.pubsub_token);
        const el = document.getElementsByClassName("ForgetPassword")[0]
        el.removeEventListener("keyup", null)
    }
    forgetLogin = () => {
        const code = this.imgCode.getValue();
        const { accountType, value, countryCode } = this.account.getValue();
        this.setState({
            errMsg:'',
            errorInput:false
        })
        let data = accountType === "email" ? {
            "mode": "getpwd_email_code",
            "data": {
                "email": value,
                "code": code.value
            }
        } : {
            "mode": "getpwd_mobile_code",
            "data": {
                "mobile": value,
                "country_code": countryCode,  //地区编码
                "code": code.value
            }
        }
        React.axios('/user/signin', data).then(res => {
            if (res.data.code === 200) {
                tipAlert({
                    type: "success",
                    msg: res.data.msg
                })
                this.setShowPage("showEntryInput")
                PubSub.publish('codeCont', { value: this.account.getValue() });
            }else if(res.data.code===400){
                tipAlert({
                    type: "error",
                    msg : res.data.msg
                })
            }
        }).catch(res => {
            const res1 =  res.response ? res.response.data : res.data;
            this.imgCode.changeCode()
            if (res1.toString().indexOf('"Message":"OK"') === -1) {
                if (res1.toString().indexOf('code')) {
                    this.setState({
                        errMsg:res1.msg,
                        errorInput:true
                    })
                }
                else {
                    this.setState({
                        errMsg:React.language("System.error"),
                        errorInput:true
                    })
                }
            } else {
                tipAlert({
                    type: "success",
                    msg: res1.msg
                })
                this.setShowPage("showEntryInput")
                PubSub.publish('codeCont', { value: this.account.getValue() });
            }
        })
    }

    setShowPage = (s) => {
        const { pageSwitch } = this.state;
        for (let key in pageSwitch) {
            pageSwitch[key] = false;
            if (key === s) pageSwitch[key] = true;
        }
        this.setState({ pageSwitch: pageSwitch });
    }

    setNesPassword = () => {
        const { password } = this.state;
        this.passwordValue();
        if (!this.state.passLevel) {
            tipAlert({
                type: "error",
                msg: React.language('set.password.tip')
            })
            this.setState({
                errMsg:React.language("set.password.tip"),
                errorInput:true
            })
            return
        }
        React.axios('/user/signin', {
            "mode": "getpwd_setpwd",
            "data": {
                "pwd": password, //密码 不能为空
            }
        }).then(res => {
            if (res.data.code === 200) {
                tipAlert({
                    type: "success",
                    msg: res.data.msg
                })
                window.location.href = window.rootDirectroy + "/user/login"
            }else if(res.data.code===400){
                tipAlert({
                    type: "error",
                    msg : res.data.msg
                })
            }
        }).catch(res => {
            const res1 =  res.response ? res.response.data : res.data;
            this.setState({
                errMsg:res1.msg,
                errorInput:true
            })
        })
    }

    changeValue = (event) => {
        const val = event.target.value
        if (val !== '') {
            this.setState({ showClear: true, showPassword: true })
        } else {
            this.setState({ showClear: false, showPassword: false })
        }
        this.setState({ password: val })
        PubSub.publish('levelValue', { value: val });
    }

    clearInputValue = (event) => {
        event.target.previousSibling.value = "";
        event.target.parentNode.classList.remove('phone')
        this.setState({ showClear: false, showPassword: false })
    }

    changePasswordType = () => {
        this.setState({
            showPasswordType: !this.state.showPasswordType
        })
    }

    render() {
        const { showEntryInput, showForgetCont, showSetPasswordInput } = this.state.pageSwitch
        const { showClear, showPasswordType, showPassword, password, errMsg, errorInput} = this.state
        return (
            <div className="ForgetPassword">
                {showForgetCont && <div className="forgetCont">
                    <div className="title">{React.language('passForget')}</div>
                    <div className="error-msg">
                        {errMsg}
                    </div>
                    <LoginAccountInput error={errorInput} value={this.account ? this.account.getValue().value : ""} getValue={this.accountValue} />
                    <ImgCodeInput error={errorInput} getValue={this.imgCodeValue} />
                    <BsyBtn onClick={this.forgetLogin} text={React.language('m.code.send')} />
                </div>}
                {showEntryInput && <EntryInputCode LoginCode={this.forgetPasswordCode} type="getpwd" />}
                {showSetPasswordInput && <div className="setPasswordCont">
                    <div className="title">{React.language('set.password.new')}</div>
                    <div className="verification">
                        <input onChange={this.changeValue} type={showPasswordType ? "text" : "password"} placeholder={React.language('password.set.warning')} />
                        {showClear && <i onClick={this.clearInputValue} className="icon-dingding-guide-close" />}
                        {showPassword && <i onClick={this.changePasswordType} className={showPasswordType ? "changePasswordType icon-bsy-filter-show" : "changePasswordType icon-bsy-filter-hide"} />}
                        {showPassword && <LoginPasswordLevel getIsPass={this.passwordValue} password={password} />}
                    </div>
                    <BsyBtn style={{ "marginTop": "10rem" }} onClick={this.setNesPassword} text={React.language('passReset')} />
                </div>}
            </div>
        );
    }
}

export default ForgetPassword;